function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { Drawer } from "vaul";
import { Cross } from "@bolteu/kalep-react-icons";
import { cx } from "../../helpers/utils/cx";
import { IconButton } from "../IconButton";
export const KALEP_BOTTOMSHEET_CONTENT_ID = "kalep__bottom-sheet-content"; // TODO: Not the best solution, but works until we find a better one - https://taxify.slack.com/archives/C049ZD40C1Y/p1738321322242899

export function BottomSheet(_ref) {
  let {
    children,
    isOpen,
    onOpenChange,
    onAnimationChange,
    isDismissible = true,
    hasOverlay = true,
    hasHandle = true,
    hasCloseButton,
    snapPoints,
    container
  } = _ref;
  const handleCloseButtonClick = React.useCallback(() => {
    onOpenChange(false);
  }, [onOpenChange]);
  const snapPointsProps = Array.isArray(snapPoints) ? {
    snapPoints
  } : {};
  return /*#__PURE__*/React.createElement(Drawer.Root, _extends({
    open: isOpen,
    onOpenChange: onOpenChange,
    onAnimationEnd: onAnimationChange,
    dismissible: isDismissible,
    fadeFromIndex: 0,
    container: container,
    repositionInputs: false
  }, snapPointsProps), /*#__PURE__*/React.createElement(Drawer.Portal, null, hasOverlay && /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: cx("z-50 fixed inset-0 bg-special-scrim")
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: cx("fixed bottom-0 left-0 right-0 z-50", "bg-layer-floor-1 outline-none rounded-t-lg", "max-h-[97vh]", Array.isArray(snapPoints) ? "h-full" : "h-fit")
  }, hasCloseButton && /*#__PURE__*/React.createElement(Drawer.Close, {
    asChild: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    variant: "secondary",
    icon: /*#__PURE__*/React.createElement(Cross, null),
    "aria-label": "Close" // TODO: Add proper localisation
    ,
    onClick: handleCloseButtonClick,
    overrideClassName: cx("absolute top-2 right-2 rtl:right-auto rtl:left-2"),
    size: "sm"
  })), hasHandle && /*#__PURE__*/React.createElement(Drawer.Handle, {
    className: cx("my-2 !bg-neutral-secondary-hard")
  }), /*#__PURE__*/React.createElement("div", {
    className: cx("flex flex-col"),
    style: {
      maxHeight: "inherit",
      height: "inherit"
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: KALEP_BOTTOMSHEET_CONTENT_ID,
    className: cx("flex-1 overflow-y-auto")
    // eslint-disable-next-line no-inline-styles/no-inline-styles -- Tailwind does not support this yet - https://github.com/tailwindlabs/tailwindcss/discussions/1361
    ,
    style: {
      maxHeight: "inherit",
      height: "inherit"
    }
  }, children)))));
}